import styled from "styled-components";
// import ImgBg from "../../images/hero.jpg";

export const ContactContainer = styled.div`
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1)),
    url("https://st4.depositphotos.com/21389766/23112/i/450/depositphotos_231122574-stock-photo-contact-contact-write-email-support.jpg");
  /* height: 100vh; */
  background-position: center;
  background-size: cover;
`;
